import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { toCountryCode } from '../../types/CountryCode';
import { toLanguageCode } from '../../types/LanguageCode';
import { Settings } from './settingsTypes';

export const initialSettingsState: Settings = {
    countryCode: toCountryCode('SE'),
    languageCode: toLanguageCode('SV'),
    authenticationScope: undefined,
    oAuthBaseUrl: '',
    proxyBaseUrl: '',
    validationUrl: '',
    handleDocumentUrl: '',
    translationUrl: '',
    simpleFormUrl: '',
    apiKey: '',
    originatingUrl: 'https://resurs.se',
    checkOngoing: true,
    withCoApplicant: true,
    withCoApplicantConsolidations: true,
    showPpiPage: false,
};

// Selectors
export const selectSettings = (state: any) => {
    return (state?.settings ?? undefined) as Settings;
};

export const settingsSlice = createSlice({
    name: 'settings',
    initialState: initialSettingsState,
    reducers: {
        setSettings: (state: any, action: PayloadAction<Settings>) => {
            state.countryCode = action.payload.countryCode;
            state.languageCode = action.payload.languageCode;
            state.authenticationScope = action.payload.authenticationScope;
            state.oAuthBaseUrl = action.payload.oAuthBaseUrl;
            state.proxyBaseUrl = action.payload.proxyBaseUrl;
            state.validationUrl = action.payload.validationUrl;
            state.handleDocumentUrl = action.payload.handleDocumentUrl;
            state.translationUrl = action.payload.translationUrl;
            state.simpleFormUrl = action.payload.simpleFormUrl;
            state.apiKey = action.payload.apiKey;
            state.originatingUrl = action.payload.originatingUrl;
            state.checkOngoing = action.payload.checkOngoing;
            state.withCoApplicant = action.payload.withCoApplicant;
            state.withCoApplicantConsolidations = action.payload.withCoApplicantConsolidations;
            state.showPpiPage = action.payload.showPpiPage;
        },
    },
});

export const { setSettings } = settingsSlice.actions;

export default settingsSlice.reducer;
